import { render, staticRenderFns } from "./picCard.vue?vue&type=template&id=d1a0fda0&scoped=true"
import script from "./picCard.vue?vue&type=script&lang=js"
export * from "./picCard.vue?vue&type=script&lang=js"
import style0 from "./picCard.vue?vue&type=style&index=0&id=d1a0fda0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a0fda0",
  null
  
)

export default component.exports